import { useMotionValue, animate } from 'motion/react';
import { useMixed } from './use-mixed.mjs';
import { useEffect } from 'react';

function useSnapToTarget(pointer, isEnabled, state) {
    const crossfade = useMotionValue(0);
    const targetCenterX = useMotionValue(0);
    const targetCenterY = useMotionValue(0);
    const x = useMixed(pointer.x, targetCenterX, crossfade);
    const y = useMixed(pointer.y, targetCenterY, crossfade);
    useEffect(() => {
        if (!isEnabled)
            return;
        if (state.targetBoundingBox) {
            targetCenterX.set(state.targetBoundingBox.left + state.targetBoundingBox.width / 2);
            targetCenterY.set(state.targetBoundingBox.top + state.targetBoundingBox.height / 2);
        }
        const animation = animate(crossfade, state.targetBoundingBox ? 0.9 : 0);
        return () => animation.stop();
    }, [state.targetBoundingBox, isEnabled]);
    return { x, y };
}

export { useSnapToTarget };
